import { gql } from "gql";

export const GET_TASKS_NOTIFICATION_LIST = gql(/* GraphQL */ `
  query GetTasksNotificationList(
    $filter: TaskFilter!
    $sort: TaskSort!
    $page: PageRequest!
  ) {
    getTaskList(filter: $filter, sort: $sort, page: $page) {
      total
      content {
        ...NotificationListItemTask
      }
    }
  }
`);
